import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { get } from 'lodash';

import Section from '../../common/Section';
import Carousel from './Carousel';
import Anchor from '../utils/Anchor';
import TextBlockWithIcon from '../textBlock/TextBlockWithIcon';
import { BLOCK_TYPE, blocksToComponents } from '../utils/Contentful';

const Wrapper = styled(Section)`
  padding-top: var(--default-vertical-padding);
  padding-bottom: calc(2 * var(--fr));
  padding-left: var(--fr);
  padding-right: var(--fr);
`;

const Item = styled.div`
  display: flex !important;
  height: 100%;
  position: relative;
  flex-flow: column;

  h2 {
    font-size: var(--fs-m);
    margin-bottom: 2rem;
  }

  h3 {
    font-size: var(--fs-sm);
    font-weight: 500;
    margin-bottom: calc(var(--fr) * 0.75);
  }

  img {
    width: 100%;
  }
`;

const DiscoverCarousel = ({ content }) => {
  const { title, textBlock, blocks, blockId, hideArrows } = content;
  const hasTextBlock = blocks.some(
    block => block.sys.contentType.sys.id === BLOCK_TYPE.ONE_COLUMN_BLOCK
  );

  return (
    <React.Fragment>
      <Anchor id={blockId} />
      <Wrapper>
        {get(textBlock, 'fields') && (
          <TextBlockWithIcon
            content={textBlock.fields}
            className="header"
            srcBlockName={`Discover Carousel - ${title}`}
          />
        )}
        {blocks && (
          <Carousel freeMode={!hasTextBlock} hideArrows={hideArrows}>
            {blocks.map(block => {
              return (
                <Item key={block.sys.id}>
                  {blocksToComponents({
                    block,
                    src: BLOCK_TYPE.DISCOVER_CAROUSEL,
                  })}
                </Item>
              );
            })}
          </Carousel>
        )}
      </Wrapper>
    </React.Fragment>
  );
};

DiscoverCarousel.propTypes = {
  content: PropTypes.object,
};

export default DiscoverCarousel;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/carousel/DiscoverCarousel.js